// extracted by mini-css-extract-plugin
module.exports = {"selectFilterMobile":"CategoriesSelect_selectFilterMobile__3GmpR","selectFilter":"CategoriesSelect_selectFilter__VbqZz"};